import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectLoggedIn } from '../store/slice/auth/slice';
import { selectUserInfo } from '../store/slice/vendor/slice';

const PrivateLayout = () => {
  const isAuthenticated = useSelector(selectLoggedIn);
  const { name, onboardingFinishedAt } = useSelector(selectUserInfo);

  const location = useLocation();
  if (!isAuthenticated || (isAuthenticated && !onboardingFinishedAt)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateLayout;
